import { createContext, useState } from 'react';

interface ICollectionContextProvider {
	collection: 'creators' | 'videos' | 'creators-group' | 'videos-group';
	data: any;
	modalData: any;

	isAddToCollectionModalOpen: boolean;
	isAddNewCollectionModalOpen: boolean;
	isAddCreatorToCollectionModalOpen: boolean;

	setData: React.Dispatch<any>;
	setModalData: React.Dispatch<any>;
	setCollection: React.Dispatch<any>;
	setIsAddToCollectionModalOpen: React.Dispatch<boolean>;
	setIsAddNewCollectionModalOpen: React.Dispatch<boolean>;
	setIsAddCreatorToCollectionModalOpen: React.Dispatch<boolean>;
}

export const CollectionContext = createContext<ICollectionContextProvider>(
	{} as ICollectionContextProvider,
);

type TProps = {
	children: React.ReactNode[];
};

export const CollectionsContextProvider = ({ children }: TProps) => {
	const [collection, setCollection] =
		useState<ICollectionContextProvider['collection']>('videos');
	const [data, setData] = useState<ICollectionContextProvider['data']>(null);
	const [modalData, setModalData] =
		useState<ICollectionContextProvider['modalData']>(null);
	const [isAddToCollectionModalOpen, setIsAddToCollectionModalOpen] =
		useState(false);
	const [isAddNewCollectionModalOpen, setIsAddNewCollectionModalOpen] =
		useState(false);
	const [
		isAddCreatorToCollectionModalOpen,
		setIsAddCreatorToCollectionModalOpen,
	] = useState(false);

	return (
		<CollectionContext.Provider
			value={{
				collection,
				setCollection,
				data,
				setData,
				modalData,
				setModalData,
				isAddToCollectionModalOpen,
				setIsAddToCollectionModalOpen,
				isAddNewCollectionModalOpen,
				setIsAddNewCollectionModalOpen,
				isAddCreatorToCollectionModalOpen,
				setIsAddCreatorToCollectionModalOpen,
			}}
		>
			{children}
		</CollectionContext.Provider>
	);
};
